import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchInterests'
})

export class SearchInterestsPipe implements PipeTransform {

  transform(pipeData, pipeModifier): any {
    if (pipeModifier != 'TOPIC/INTEREST') {
      return pipeData.filter(eachItem => {
        if (eachItem['fields']['interests']) {
          return (
            eachItem['fields']['interests'].includes(pipeModifier)
          )
        }
      });
    } else {
      return pipeData
    }
  }
}